import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getSliders } from "../services/api";
import { getImageUrl } from "../utils/imageHelper";

export default function Slider() {
  const [sliders, setSliders] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchSliders();
  }, []);

  const fetchSliders = async () => {
    try {
      const data = await getSliders();
      if (data && data.length > 0) {
        setSliders(data);
      } else {
        // Fallback or default sliders if database is empty
        setSliders([
          {
            id: 'd1',
            title: "Kesenian Otentik Bali",
            description: "Karya tangan para pengrajin terbaik dari pulau dewata, menghadirkan estetika budaya di setiap detilnya.",
            image: "/images/sliders/slide1.png",
            link: "/products"
          },
          {
            id: 'd2',
            title: "Gaya Hidup Alami",
            description: "Sentuhan anyaman rotan berkualitas untuk melengkapi keseharian Anda yang penuh makna.",
            image: "/images/sliders/slide2.png",
            link: "/products"
          },
          {
            id: 'd3',
            title: "Warisan Budaya",
            description: "Eksplorasi koleksi perak buatan tangan yang menceritakan sejarah dan filosofi Bali.",
            image: "/images/sliders/slide3.png",
            link: "/products"
          }
        ]);
      }
    } catch (err) {
      console.error("Failed to fetch sliders", err);
    }
  };

  useEffect(() => {
    if (sliders.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % sliders.length);
    }, 8000); // 8 seconds for better readability
    return () => clearInterval(interval);
  }, [sliders]);

  if (sliders.length === 0) return null;

  return (
    <div className="hero-slider">
      {sliders.map((slide, index) => (
        <div
          key={slide.id}
          className={`slide ${index === currentIndex ? "active" : ""}`}
        >
          <img
            src={getImageUrl(slide.image, '/images/sliders/slide1.png')}
            alt={slide.title}
            className="slide-image"
          />
          <div className="slide-overlay" />
          <div className="slide-content">
            <h1 className="slide-title">{slide.title}</h1>
            <p className="slide-description">{slide.description}</p>
            <Link to={slide.link || "/products"} className="btn btn-primary btn-slider">
              Eksplorasi Sekarang
            </Link>
          </div>
        </div>
      ))}

      <div className="slider-controls">
        {sliders.map((_, index) => (
          <div
            key={index}
            className={`slider-dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
}
